import MaturityScheduleReport from "../components/maturityScheduleReport";
import { AppContext } from "../context/AppContext";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

const InvestmentsPage = () => {
  const [investments, setInvestments] = useState([]);
  const token = localStorage.getItem("token");
  const { company } = useContext(AppContext);

  // Fetch investments data from API
  useEffect(() => {
    const fetchInvestments = async () => {
      const response = await axios.get(
        `https://zedlenders.pickmesms.com/items/investments?filter[company]=${company?.id}&fields=*,investor_id.*`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setInvestments(response.data.data);
    };

    fetchInvestments();
  }, []);

  return (
    <div className="page-container">
      <MaturityScheduleReport investments={investments} />
    </div>
  );
};

export default InvestmentsPage;
